/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

export default (router) => {
    router(`/dashboard/support`, controller.support, makeLayout, render);
    router(`/dashboard/support/edit`, controller.editSupport, makeLayout, render);
    router(`/dashboard/support/new`, controller.newSupport, makeLayout, render);
};
